import React from 'react';
import { ChevronRight } from 'lucide-react';

const Sidebar = ({ sections, activeSection, onSectionClick }) => {
  return (
    <div className="w-64 bg-gray-50 border-r border-gray-200 py-8 px-4 hidden lg:block">
      <div className="fixed w-64 overflow-y-auto">
        <nav className="space-y-1">
          {sections.map((section) => (
            <div key={section.id}>
              <button
                onClick={() => onSectionClick(section.id)}
                className={`w-full text-left px-3 py-2 rounded-md text-sm font-medium ${
                  activeSection === section.id
                    ? 'bg-blue-50 text-blue-700'
                    : 'text-gray-700 hover:bg-gray-100'
                }`}
              >
                {section.title}
              </button>
              {section.subsections && (
                <div className="ml-4 mt-1 space-y-1">
                  {section.subsections.map((subsection) => (
                    <button
                      key={subsection.id}
                      onClick={() => onSectionClick(subsection.id)}
                      className={`w-full text-left px-3 py-1.5 rounded-md text-sm ${
                        activeSection === subsection.id
                          ? 'text-blue-700 bg-blue-50'
                          : 'text-gray-600 hover:bg-gray-100'
                      }`}
                    >
                      <ChevronRight className="inline w-3 h-3 mr-1" />
                      {subsection.title}
                    </button>
                  ))}
                </div>
              )}
            </div>
          ))}
        </nav>
      </div>
    </div>
  );
};

export default Sidebar;